export default __webpack_public_path__ + "static/media/gear-cog-wheel.5c64073d.svg";